import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Megaphone, ExternalLink, Image, FileText, Video, Share2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function MarketingHub({ userInfo }) {
  return (
    <div className="space-y-6 p-6">
      {/* Header */}
      <div className="flex items-center gap-3">
        <div className="p-3 bg-[#d4af37]/10 rounded-xl">
          <Megaphone className="w-6 h-6 text-[#d4af37]" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-neutral-800">Marketing Hub</h1>
          <p className="text-sm text-neutral-500">Access marketing resources and materials</p>
        </div>
      </div>

      {/* Coming Soon Message */}
      <Card>
        <CardContent className="flex flex-col items-center justify-center py-12">
          <div className="p-4 bg-neutral-100 rounded-full mb-4">
            <Megaphone className="w-12 h-12 text-neutral-400" />
          </div>
          <h3 className="text-xl font-semibold text-neutral-800 mb-2">Marketing Hub Coming Soon</h3>
          <p className="text-neutral-500 text-center max-w-md mb-6">
            We're building a comprehensive marketing resource center with templates, materials, and tools to help you grow your business.
          </p>
          
          {/* Preview of Future Features */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full max-w-4xl mt-8">
            <div className="p-4 border border-neutral-200 rounded-lg bg-white">
              <div className="flex items-center gap-3 mb-2">
                <div className="p-2 bg-blue-50 rounded">
                  <Image className="w-5 h-5 text-blue-600" />
                </div>
                <h4 className="font-semibold text-sm text-neutral-700">Brand Assets</h4>
              </div>
              <p className="text-xs text-neutral-500">Logos, images, and brand guidelines</p>
            </div>
            
            <div className="p-4 border border-neutral-200 rounded-lg bg-white">
              <div className="flex items-center gap-3 mb-2">
                <div className="p-2 bg-green-50 rounded">
                  <FileText className="w-5 h-5 text-green-600" />
                </div>
                <h4 className="font-semibold text-sm text-neutral-700">Templates</h4>
              </div>
              <p className="text-xs text-neutral-500">Email templates and marketing materials</p>
            </div>
            
            <div className="p-4 border border-neutral-200 rounded-lg bg-white">
              <div className="flex items-center gap-3 mb-2">
                <div className="p-2 bg-purple-50 rounded">
                  <Video className="w-5 h-5 text-purple-600" />
                </div>
                <h4 className="font-semibold text-sm text-neutral-700">Video Content</h4>
              </div>
              <p className="text-xs text-neutral-500">Training videos and promotional content</p>
            </div>
            
            <div className="p-4 border border-neutral-200 rounded-lg bg-white">
              <div className="flex items-center gap-3 mb-2">
                <div className="p-2 bg-orange-50 rounded">
                  <Share2 className="w-5 h-5 text-orange-600" />
                </div>
                <h4 className="font-semibold text-sm text-neutral-700">Social Media</h4>
              </div>
              <p className="text-xs text-neutral-500">Ready-to-share social media posts</p>
            </div>
            
            <div className="p-4 border border-neutral-200 rounded-lg bg-white">
              <div className="flex items-center gap-3 mb-2">
                <div className="p-2 bg-pink-50 rounded">
                  <ExternalLink className="w-5 h-5 text-pink-600" />
                </div>
                <h4 className="font-semibold text-sm text-neutral-700">Resources</h4>
              </div>
              <p className="text-xs text-neutral-500">Marketing guides and best practices</p>
            </div>
            
            <div className="p-4 border border-neutral-200 rounded-lg bg-white">
              <div className="flex items-center gap-3 mb-2">
                <div className="p-2 bg-yellow-50 rounded">
                  <Megaphone className="w-5 h-5 text-yellow-600" />
                </div>
                <h4 className="font-semibold text-sm text-neutral-700">Campaigns</h4>
              </div>
              <p className="text-xs text-neutral-500">Pre-built marketing campaigns</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
